module.exports = "https://p.cds.unp.clasificados.pe/bg-inmuebles.4a5e104448cbbfb6bb01ed53a39a6b3d.jpg";